/* eslint-disable jsx-a11y/no-redundant-roles */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import PasswordInput from 'components/input/PasswordInput';
import TextIconInput from 'components/input/TextIconInput';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import React, { useRef, useState } from 'react';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { Button, Card, CloseButton, Col, Spinner } from 'react-bootstrap';
import { GoogleLogin } from '@react-oauth/google';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router';
import { routers } from 'router/router';
import { mergeSearchPreserveInvite } from 'utils/partnerInvite';
import { 
  mediumPasswordRegexp, 
  strongPasswordRegexp, 
} from 'components/helper/helper';
import { useAppDispatch } from 'app/hooks';
import SessionExistsModal from '../login/SessionExistsModal';
import { USER_ROLE } from 'constants/common';
import {  login,  googlerRegister } from 'app/authorization/authorizationSlice';

function toTitleCase(str:string) {
  return str.replace(
    /\w\S*/g,
    function(txt:string) {
      return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
    }
  );
}

// Component nút Google tùy chỉnh
const CustomGoogleButton = ({ onGoogleLoginSuccess, onGoogleLoginError }: any) => {
  const googleLoginRef = useRef<HTMLDivElement>(null);
  const [isHovered, setIsHovered] = React.useState(false);

  // Xử lý khi người dùng nhấp vào nút tùy chỉnh
  const handleCustomButtonClick = () => {
    // Tìm và kích hoạt nút Google ẩn
    if (googleLoginRef.current) {
      const googleButton = googleLoginRef.current.querySelector('div[role="button"]');
      if (googleButton instanceof HTMLElement) {
        googleButton.click();
      } else {
        toast.error('Cannot connect to Google. Login failed');
      }
    }
  };

  return (
    <>
      {/* Nút tùy chỉnh */}
      <Button
        className="custom-google-btn"
        variant="light"
        onClick={handleCustomButtonClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}        
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <img
            src="https://developers.google.com/identity/images/g-logo.png"
            alt="Google logo"
            style={{ width: 18, height: 18, marginRight: 10 }}
          />
          <span
            style={{
              fontSize: '14px',
              fontWeight: '500',
              fontFamily: 'Roboto, Arial, sans-serif',
              color: '#3c4043',
            }}
          >
            Continue with Google
          </span>
        </div>
      </Button>

      {/* Component Google Login ẩn */}
      <div ref={googleLoginRef} style={{ display: 'none', position: 'absolute', left: '-9999px' }}>
        <GoogleLogin
          onSuccess={onGoogleLoginSuccess}
          onError={() => {
            if (onGoogleLoginError) {
              onGoogleLoginError();
            } else {
              toast.error('Google login failed');
            }
          }}
          type="standard"
          theme="outline"
          text="signin_with"
          shape="rectangular"
          logo_alignment="center"
        />
      </div>
    </>
  );
};

interface Props {
  onNextStep: (step: string, force?: boolean) => void;
  formik: any;
  provider?: any;
  loginCredentials?: any;
  setLoginCredentials: (values:any) => void;
  setProvider: (values:any) => void;
  /** When set via partner invite validate — email must match invitee */
  inviteEmailLocked?: boolean;
  /** Parent holds button disabled through createStudent → login (Redux `loading` goes idle between them). */
  registerCreateLocked: boolean;
  setRegisterCreateLocked: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface passwordStrengthProps {
  title: string;
  content: string;
  status: string;
}


const FormRegister = ({
  formik,
  provider,
  setProvider,
  onNextStep,
  loginCredentials,
  setLoginCredentials,
  inviteEmailLocked,
  registerCreateLocked,
  setRegisterCreateLocked,
}: Props) => {
  let history = useHistory();
  const dispatch:any = useAppDispatch();
  const [sessionExistsModal, setSessionExistsModal] = useState({
    open: false,
    message: '',
    activeSessions: [] as Array<{ device: string; lastSeen: string; ipAddress: string }>,
  });
  
  
  const [passwordStrength, setPasswordStrength] = React.useState<passwordStrengthProps | undefined>(
    undefined
  );
  //const finishYearOptions = [1, 2, 3, 4, 5].map((i) => i + new Date().getFullYear());
  //const [agreeTerm, setAgreeTerm] = React.useState(true);

  // const query = new URLSearchParams(useLocation().search);
  // const email = query.get('email');
  // const first_name = query.get('first_name');
  // const last_name = query.get('last_name');

  React.useEffect(() => {
    const userRole = sessionStorage.getItem('userRole');
    if (userRole) {
      formik.setFieldValue('user_role',userRole);
    }
  }, []);
  

  React.useEffect(() => {
    // if(email) {
    //   formik.setFieldValue('email', email);
    // }

    // if(first_name) {
    //   formik.setFieldValue('first_name', first_name);
    // }

    // if(last_name) {
    //   formik.setFieldValue('last_name', last_name);
    // }

    if (!provider && formik.values.password.length > 1 && formik.values.password_confirm.length>1) {
      if (strongPasswordRegexp.test(formik.values.password)) {
        setPasswordStrength({
          title: 'Strong Password',
          content: 'Great! This would do, now just don’t forget it.',
          status: 'text-success',
        });
      } else if (mediumPasswordRegexp.test(formik.values.password)) {
        setPasswordStrength({
          title: 'Medium Password',
          content:
            'This password look good. Add one lowercase letter , one uppercase letter , one digit , one special character for stronger.',
          status: 'text-warning',
        });
      } else {
        setPasswordStrength({
          title: 'Weak Password',
          content: 'You password is too weak.',
          status: 'text-danger',
        });
      }
    }
  }, [formik.values.password]);
  

  const handleGoogleLoginError = () => {
    toast.error('Google login failed');
  };

  const handleGoogleLogin = async (credentialResponse: any) => {
    try {
      // Extract the credential (ID token) from the response
      const tokenId = credentialResponse.credential;

      const res: any = await dispatch(
        googlerRegister({
          tokenId: tokenId,
          force: true
        })
      );

      if (res.payload) {
        console.log('should_register res:', res);
        if (res.payload?.should_register) {
          formik.setFieldValue('email', res.payload?.email, false);
          formik.setFieldValue('first_name', res.payload?.name?.first_name, false);
          formik.setFieldValue('last_name', res.payload?.name?.last_name, false);
          formik.setFieldValue('password', 'Demo123@student.com', false);
          formik.setFieldValue('password_confirm', 'Demo123@student.com', false);
          formik.setFieldValue('google_id', res.payload?.google_id, false);
          await formik.submitForm();
          onNextStep('3a', true);
        }
        else {
          setProvider(true);
          onNextStep('3a', true);
        }
      }      
    } catch (error) {
      console.log({ error });
    }
  };
 
  const handleCloseSessionModal = () => {
    setSessionExistsModal({
      open: false,
      message: '',
      activeSessions: [],
    });
    setLoginCredentials(null);
  };
   
  const handleContinueLogin = async () => {
    if (!loginCredentials) {
      handleCloseSessionModal();
      return;
    }

    try {
      // Close modal first
      handleCloseSessionModal();
      
      // Call login API again with force=true
      const loginPayload = {
        ...loginCredentials,
        force: true,
      };
      
      const res: any = await dispatch(login(loginPayload));
      console.log('login res:', res);

      if (res?.error?.message === 'User not found') {
        toast.error('User not found');
        history.push(routers.register.path);
        return;
      }
      if (res?.error?.message === 'Network Error') {
        toast.error('Network Error: Please check your internet connection or backend server.');
        return;
      }

      if (res.payload) {
        // Handle successful login - reuse the same logic from onSubmit
        if (res.payload.statusCode === 400) {
          if (res.payload.message === 'User not found') {
            toast.error('User not found');
            return;
          }
          if (res.payload.errorCode === 100) {
            toast.error('Invalid User or Password');
          } else {
            toast.error(res.payload.message);
          }
          return;
        } else if (res.payload.statusCode === 500) {
          toast.error(res.payload.message);
          return;
        }

      }
    } catch (error: any) {
      if (error.response) {
        console.error('Server Error:', error.response.status, error.response.data);
      } else if (error.request) {
        console.error('Network Error:', error.request);
      } else {
        console.error('Error:', error.message);
      }
    }
  };
  
  return (
    <div className="w-full max-w-2xl d-flex flex-column justify-content-evenly align-items-center">
      <div id="register-container" className="w-full max-w-md2 mx-auto">
        <div id="title-section" className="title-section d-block text-center">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-brand-blue rounded-xl mb-8">
              <i className="text-white text-2xl">
                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px"><path fill-rule="evenodd" fill="currentColor" d="M3.026,13.049 C2.730,13.093 2.521,13.136 2.200,13.203 C1.886,13.269 1.658,13.312 1.494,13.324 C1.588,12.469 1.865,10.906 2.044,9.679 C2.212,8.522 2.286,7.663 2.240,8.073 C2.316,7.402 2.363,6.821 2.398,6.152 C0.900,6.152 0.214,6.152 -0.000,6.152 C1.266,5.381 7.732,1.590 10.455,-0.000 C14.293,0.013 18.133,0.026 21.971,0.039 C21.971,0.052 21.971,0.065 21.971,0.078 C21.945,0.078 21.919,0.078 21.892,0.078 C21.638,0.320 21.260,0.399 20.949,0.588 C20.259,1.007 19.497,1.332 18.787,1.763 C17.395,2.609 15.930,3.336 14.464,4.115 C14.042,4.339 13.578,4.648 13.167,4.898 C12.871,5.078 12.560,5.150 12.263,5.329 C12.032,5.469 11.739,5.714 11.477,5.800 C8.660,5.917 5.843,6.035 3.026,6.152 C3.026,6.179 3.026,6.205 3.026,6.231 C3.149,6.414 3.233,7.828 3.249,8.839 C3.256,9.302 3.223,10.415 3.223,10.737 C3.157,11.508 3.092,12.279 3.026,13.049 ZM17.923,3.723 C18.577,3.773 19.668,4.428 20.124,4.742 C20.393,4.927 20.658,5.024 20.910,5.212 C21.703,5.805 22.517,7.075 23.074,8.271 C23.279,8.711 23.816,9.703 23.986,12.040 C24.038,12.758 23.936,14.029 23.936,14.029 C23.936,14.029 23.792,15.151 23.622,15.675 C22.548,18.975 20.207,20.902 16.704,21.788 C16.112,21.938 15.392,21.979 14.739,21.984 C12.217,22.108 10.801,21.524 10.011,21.201 C9.005,20.790 8.249,20.343 7.546,19.633 C6.402,18.476 5.493,16.834 5.031,14.970 C4.519,12.907 4.901,10.063 5.581,8.504 C5.679,8.279 6.075,7.338 6.210,7.250 C6.446,7.250 6.682,7.250 6.917,7.250 C7.128,7.126 7.545,7.271 7.821,7.210 C8.663,7.026 9.693,7.236 10.533,7.054 C11.005,7.041 11.477,7.028 11.948,7.015 C12.294,6.901 12.701,6.575 13.010,6.388 C13.948,5.818 14.958,5.379 15.879,4.820 C16.398,4.505 16.952,4.261 17.451,3.958 C17.610,3.861 17.795,3.846 17.923,3.723 ZM12.734,7.720 C11.806,8.015 11.020,8.473 10.455,9.131 C9.510,10.230 8.978,13.241 9.708,15.048 C9.987,15.739 10.367,16.321 10.850,16.798 C11.816,17.659 12.355,18.072 14.110,18.183 C15.145,18.097 16.088,17.876 16.939,17.410 C17.557,17.073 17.989,16.691 18.316,16.341 C18.855,15.762 19.088,15.235 19.259,14.891 C19.332,14.745 19.410,14.402 19.495,14.264 C19.569,14.183 20.125,13.881 20.202,13.833 C20.995,13.343 22.448,12.497 22.443,12.501 C21.381,12.057 20.320,11.612 19.259,11.168 C18.992,10.522 18.652,9.959 18.266,9.482 C17.918,9.054 16.775,7.638 14.434,7.532 C14.705,7.544 13.389,7.512 12.734,7.720 ZM15.093,9.954 C15.742,9.944 15.819,10.220 16.115,10.541 C16.145,11.238 16.015,11.264 15.643,11.639 C15.409,11.661 15.078,11.727 14.896,11.599 C14.371,11.438 14.373,10.850 14.503,10.345 C14.611,10.276 14.677,10.132 14.778,10.071 C14.884,10.008 15.001,10.022 15.093,9.954 Z"/></svg>
              </i>
          </div>
          <h1 className="text-3xl font-semibold text-neutral-900 mb-2">Create your free GradMap account</h1>
          <p className="text-neutral-600 text-base">Start planning your college journey today</p>          
        </div>
        <div id="setup-form-container" className="bg-white rounded-2xl shadow-xl border border-gray-100 form2-wrap">
          <div className="row">
              <div className="col-md-12">
                <CustomGoogleButton
                  onGoogleLoginSuccess={handleGoogleLogin}
                  onGoogleLoginError={handleGoogleLoginError}
                />
                <p className="text-center text-sm text-neutral-500 mb-6">Fastest option — no password required</p>
              </div>
          </div>

          <div className="row">
            <div className="col-md-6 py-2 pe-md-2">
            <TextIconInput
              placeholder="John"
              className="signup-form"
              icon={<PersonOutlineIcon />}
              mdCol={'6'}
              label={`First name (${toTitleCase(formik.values.user_role)})`}
              name='first_name'
              values={formik.values.first_name}
              onChange={formik.handleChange}
              feedback={
                formik.errors.first_name && (
                  <span className="text-danger">{formik.errors.first_name}</span>
                )
              }
            />
            </div>
            <div className="col-md-6 py-2 ps-md-2">
              <TextIconInput
                placeholder="Smith"
                className="signup-form"
                icon={<PersonOutlineIcon />}
                mdCol={'6'}
                label={`Last name (${toTitleCase(formik.values.user_role)})`}
                name='last_name'
                values={formik.values.last_name}
                onChange={formik.handleChange}
                feedback={
                  formik.errors.last_name && (
                    <span className="text-danger">{formik.errors.last_name}</span>
                  )
                }
              />
            </div>
          </div>
            
          <div className="row">
            <div className="col-md-12 py-2">
              <TextIconInput
                placeholder="john@example.com"
                className="signup-form"
                icon={<MailOutlineIcon />}
                mdCol={'6'}
                label={`Email (${toTitleCase(formik.values.user_role)})`}
                name='email'
                values={formik.values.email}
                onChange={formik.handleChange}
                disabled={Boolean(inviteEmailLocked)}
                feedback={
                  formik.errors.email && <span className="text-danger">{formik.errors.email}</span>
                }
              />
              {inviteEmailLocked && (
                <p className="small text-muted mt-1 mb-0">
                  This email is set by your invitation.{' '}
                  <button
                    type="button"
                    className="btn btn-link btn-sm p-0 align-baseline"
                    onClick={() =>
                      history.push({
                        pathname: routers.login.path,
                        search: mergeSearchPreserveInvite('', {}),
                      })
                    }
                  >
                    Already have an account? Sign in
                  </button>
                </p>
              )}
            </div>
          </div>

          {!provider && (
            <div className="row">
              <PasswordInput
                title="Create a strong password"
                textClass="signup-form"
                mdCol={'6'}
                label='Password'
                name='password'
                values={formik.values.password}
                onChange={formik.handleChange}
                feedback={
                  formik.errors.password && (
                    <span className="text-danger">{formik.errors.password}</span>
                  )
                }
              />
              <PasswordInput
                textClass="signup-form"
                mdCol={'6'}
                label='Password confirmation'
                name='password_confirm'
                values={formik.values.password_confirm}
                onChange={formik.handleChange}
                feedback={
                  formik.errors.password_confirm && (
                    <span className="text-danger">{formik.errors.password_confirm}</span>
                  )
                }
              />
            </div>
          )}
          {passwordStrength && (
            <div className="row">
            <Col sm={12}>
              <Card className="my-3 p-1 py-0 border" body>
                <div className="d-flex justify-content-between">
                  <span className={`h5 ${passwordStrength.status}`}>{passwordStrength.title}</span>
                  <CloseButton onClick={() => setPasswordStrength(undefined)} />
                </div>
                <p className="h6">{passwordStrength.content}</p>
              </Card>
            </Col>
            </div>
          )}
          
          <div className="text-center">
            <Button
              type='button'
              style={{height:'48px'}}
              className="w-100 p-2 my-3"
              variant="primary"
              disabled={formik.isSubmitting || registerCreateLocked}
              onClick={async (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (formik.isSubmitting || registerCreateLocked) {
                  return;
                }
                switch (formik.values.user_role) {
                  case USER_ROLE.student:
                  case USER_ROLE.parent:
                  case USER_ROLE.counselor:
                    // Lock only after validation passes (see register index onSubmit).
                    // Avoids stuck "Creating Account..." when validate-email returns 400.
                    await formik.submitForm();
                    break;
                  default:
                    onNextStep('1');
                }
              }}
            >
              {(formik.isSubmitting || registerCreateLocked) ? (
                <>
                  <Spinner size="sm" animation="border" variant="light" className="me-2" />
                  <span className="h5 fw-bold">Creating Account...</span>
                </>
              ) : (
                <span className="h5 fw-bold">Create Free Account</span>
              )}
            </Button>

            <div id="terms-section" className="mt-6 text-center">
                <p className="text-xs text-neutral-500 leading-relaxed">
                    By creating an account, you agree to our 
                    <a target="_blank" rel="noreferrer" href="https://www.gradmap.com/terms-of-use" className="text-brand-blue hover:underline">Terms of Service</a> and 
                    <a href="#/public/privacy-policies" className="text-brand-blue hover:underline">Privacy Policy</a>
                </p>
            </div>
  <style scoped>{`
  #form-section > div > form > div.m-3.p-0.row > div.col-md-6.py-2.pe-md-2.pt-3 > div > label,
  label.signup-form.form-label,
  #mui-1-label > span,
  #mui-2-label > span,
  #mui-6-label > span,
  .signup-form > div > label > span {
    font-weight: 500;
    color: rgb(55 65 81 / var(--tw-text-opacity, 1))!important;
    font-size: 14px!important;
  }
  .signup-form.form-control {
    border: 1px solid #cdd7e1 !important;
    border-radius: 0.5rem !important;
    box-shadow: none !important;
    font-size: 16px !important;
  }

  `}</style>

          </div>
        </div>
      
        <div id="footer-microcopy" className="mt-6 text-center">
          <p className="text-sm text-neutral-600 font-medium">No credit card. Always free to start.</p>
        </div>

        <div id="signin-link" className="text-center">
            <p className="mt-2 text-sm text-neutral-600">Already have an account? 
                <a href="#" className="text-brand-blue font-semibold hover:underline"
                  onClick={() => history.push(routers.login.path)}
                >
                  Sign in
                </a>
            </p>
        </div>
        <SessionExistsModal
            open={sessionExistsModal.open}
            handleClose={handleCloseSessionModal}
            handleContinue={handleContinueLogin}
            message={sessionExistsModal.message}
            activeSessions={sessionExistsModal.activeSessions}
          />
      </div>
    </div>
  );
};

export default FormRegister;
